export const INDICATOR_SCORE_MAX = 5;
export const TOTAL_SCORE_MAX = 100;
export const POINTS_PER_INDICATOR_POINT = TOTAL_SCORE_MAX / INDICATOR_SCORE_MAX;

export function toPoints(score) {
  if (score === null || score === undefined) return null;
  const numeric = Number(score);
  if (!Number.isFinite(numeric)) return null;
  return numeric * POINTS_PER_INDICATOR_POINT;
}
